import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52e5e2ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Crear una cuenta")
], -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" PROTECCIÓN DE DATOS PERSONALES ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Crear ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_terms = _resolveComponent("terms")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_terms),
    _createVNode(_component_el_card, { shadow: "always" }, {
      header: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          ref: "form_ref",
          rules: _ctx.rules,
          "label-width": "170px",
          "label-position": "top",
          inline: false,
          "status-icon": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Número de documento o NIT(Sin número de verificación)",
              prop: "document"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.document,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.document) = $event)),
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Correo electrónico",
              prop: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                  type: "email"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Contraseña",
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                  type: "password",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Confirmar contraseña",
              prop: "confirm_password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.confirm_password,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirm_password) = $event)),
                  type: "password",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  underline: false,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.open_terms = true))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "accept_terms" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.accept_terms,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.accept_terms) = $event)),
                  label: "Aceptar protección de datos",
                  name: "type"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSubmit(_ctx.form_ref)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    })
  ]))
}